import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { 
    FaThLarge, 
    FaUserPlus,
    FaUsers,
    FaBuilding,
    FaList,
    FaPlusCircle,
    FaBell,
    FaUserCircle,
    FaLock,
    FaSignOutAlt,
    FaChevronDown,
    FaTimes,
    FaClipboardList,
    FaCashRegister,
    FaHistory,
    FaUserTimes
} from 'react-icons/fa';
import { useMobileMenu } from '../../overall_manager/contexts/MobileMenuContext';
import './Sidebar.css';

const Sidebar = () => {
    const location = useLocation();
    const [unreadCount, setUnreadCount] = useState(0);
    const [openDropdown, setOpenDropdown] = useState(null);
    const { isMobileMenuOpen, toggleMobileMenu } = useMobileMenu();
    const [profileData, setProfileData] = useState(null)
    const baseUrl = "https://api.burrayhr.com";


    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${baseUrl}/api/profile/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            console.log("profile",response.data);
            setProfileData(response.data);
        } catch (error) {
            console.error('Error fetching profile:', error);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);


    const handleMenuClick = (item) => {
        if (item.onClick) {
            item.onClick();
        }
        // Close mobile menu when clicking a menu item
        if (window.innerWidth <= 768) {
            toggleMobileMenu();
        }
    };

    const menuItems = [
        {
            path: "/admin-manager/dashboard",
            name: "Dashboard",
            icon: <FaThLarge />
        },
        {
            type: 'dropdown',
            name: "Departments",
            icon: <FaBuilding />,
            isOpen: openDropdown === 'departments',
            toggle: () => setOpenDropdown(openDropdown === 'departments' ? null : 'departments'),
            items: [
                {
                    path: "/admin-manager/add-department",
                    name: "Add Department",
                    icon: <FaPlusCircle />
                },
                {
                    path: "/admin-manager/departments",
                    name: "View Departments",
                    icon: <FaList />
                }
            ]
        },
        
        {
            type: 'dropdown',
            name: "Staff Management",
            icon: <FaUsers />,
            isOpen: openDropdown === 'staff',
            toggle: () => setOpenDropdown(openDropdown === 'staff' ? null : 'staff'),
            items: [
                {
                    path: "/admin-manager/add-hr-manager",
                    name: "Add Manager",
                    icon: <FaUserPlus />
                },
                
                {
                    path: "/admin-manager/add-employee",
                    name: "Add Employee",
                    icon: <FaUserPlus />
                },
                {
                    path: "/admin-manager/employees",
                    name: "All Employees",
                    icon: <FaList />
                },
                {
                    path: "/admin-manager/ex-employees",
                    name: "Ex Employees",
                    icon: <FaUserTimes />
                }
            ]
        },
        {
            path: "/admin-manager/activities",
            name: "Activities",
            icon: <FaHistory />
        },
    
        {
            path: "/admin-manager/change-password",
            name: "Change Password",
            icon: <FaLock />
        },
        {
            path: "/",
            name: "Logout",
            icon: <FaSignOutAlt />,
            onClick: () => {
                localStorage.clear();
            }
        }
    ];

    const renderMenuItem = (item) => {
        if (item.type === 'dropdown') {
            return (
                <div key={item.name} className="menu-dropdown">
                    <div 
                        className={`menu-item ${item.isOpen ? 'active' : ''}`} 
                        onClick={item.toggle}
                    >
                        <div className="menu-item-content">
                            <span className="icon">{item.icon}</span>
                            <span className="menu-text">{item.name}</span>
                        </div>
                        <FaChevronDown className={`dropdown-arrow ${item.isOpen ? 'open' : ''}`} />
                    </div>
                    <div className={`dropdown-content ${item.isOpen ? 'show' : ''}`}>
                        {item.items.map((subItem) => (
                            <Link 
                                to={subItem.path} 
                                key={subItem.name}
                                className={`menu-item sub-item ${location.pathname === subItem.path ? 'active' : ''}`}
                                onClick={() => handleMenuClick(subItem)}
                            >
                                <div className="menu-item-content">
                                    <span className="icon">{subItem.icon}</span>
                                    <span className="menu-text">{subItem.name}</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            );
        }

        return (
            <Link 
                to={item.path} 
                key={item.name} 
                className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => handleMenuClick(item)}
            >
                <div className="menu-item-content">
                    <span className="icon">{item.icon}</span>
                    <span className="menu-text">{item.name}</span>
                </div>
                {item.notification > 0 && (
                    <span className="notification-badge">{item.notification}</span>
                )}
            </Link>
        );
    };

    return (
        <div style={{backgroundColor: '#1e3a8a'}} className={`sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
                
                    <img 
                        style={{
                            width: '70px', 
                            height: '70px', 
                            backgroundColor: 'white', 
                            borderRadius: '10%',
                            objectFit: 'cover'
                        }} 
                        src={profileData?.company_data?.logo}
                        alt="Company Logo" 
                        className="sidebar-logo" 
                    />
                <button className="mobile-close-btn" onClick={toggleMobileMenu}>
                    <FaTimes />
                </button>
            </div>
            <div className="sidebar-menu">
                {menuItems.map(item => renderMenuItem(item))}
            </div>
        </div>
    );
};

export default Sidebar;
